import { render, staticRenderFns } from "./ListBuildingPositionLacksHistory.vue?vue&type=template&id=003f05d0&"
import script from "./ListBuildingPositionLacksHistory.vue?vue&type=script&lang=js&"
export * from "./ListBuildingPositionLacksHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports